import Collapse from "bootstrap.native/dist/components/collapse-native.esm";

/**
 * navigation buttons
 */
let mainNav = document.getElementById("mainNavigation");
let mainNavToggle = document.querySelector(".hamburger");
let navbarToggle = new Collapse(mainNavToggle);

mainNav.addEventListener("show.bs.collapse", function(e) {
    mainNavToggle.classList.add("is-active");
});

mainNav.addEventListener("hide.bs.collapse", function(e) {
    mainNavToggle.classList.remove("is-active");
});

/**
 * location show blade buttons
 */
let locationBtnToggle = document.getElementById("location-btn-toggle");
let locationBtnNav = document.getElementById("il-additional-btns");

if (locationBtnToggle) {
    let buttonsToggle = new Collapse(locationBtnToggle);

    locationBtnNav.addEventListener("show.bs.collapse", function(e) {
        locationBtnToggle.classList.add("is-active");
    });

    locationBtnNav.addEventListener("hide.bs.collapse", function(e) {
        locationBtnToggle.classList.remove("is-active");
    });
}


